// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","mySwiper":"Header_mySwiper__pYZQY","swiperSlide":"Header_swiperSlide__uzb2p"};